import React from 'react';
import { Link } from 'react-router-dom';

const CallToAction = ({ title = "Ready to See Your New Website?" }) => {
  return (
    <section className="py-16 bg-gradient-to-br from-primary/10 via-neutral-light to-accent/5">
      <div className="container">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            {title}
          </h2>
          <p className="text-lg mb-8">
            Website + hosting + CRM + ongoing support. Test everything for 6 months FREE. See how our system transforms your lead management with no surprise fees - transparent pricing from day one.
          </p>
          <Link to="/contact" className="btn-primary btn-lg">
            Book a Quick Call
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
